import i18n from "@/i18n";
import toast from "@/plugins/toast";
import router from "../router/index";
import { State } from "@/store/state";
import { Request } from "@/network/request";

export default class auth {
  endPoint = "login";
  token = null;

  loginState = new State();

  async login(payload) {
    let request = new Request({
      method: "post",
      endpoint: `/${this.endPoint}`,
      data: payload,
    });

    await this.loginState.trigger(
      async () => {
        return await request.send();
      },
      {
        onSuccess: (value) => {
          this.token = value.token;
          localStorage.setItem("token", value.data.token);
          localStorage.setItem("admin_id", value.data.user.chat_user_id);
          localStorage.setItem("chat_token", value.data.chat_token);
          this.token = true;
          router.push("/");
          toast(
            i18n.t("login success"),
            { timeout: 4000, rtl: true },
            "sucess"
          );
        },
        onError: (error) => {
          toast(i18n.t(error.type), { timeout: 4000, rtl: true }, "error");
        },
      }
    );
  }
}

export const Auth = new auth();
